/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
// import { motion } from "framer-motion";
import React, { useEffect, useState, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import useAuth from "../../Hooks/useAuth";
import Login from "../../sections/Login/Login";
import { SignUp } from "../../sections/SignUp/SignUp";
import MainButton from "../common/MainButton/MainButton";
import CustomerSidebarDrawer from "./CustomerSidebarDrawer";
import Avtar from "../../assets/img/default-image.jpg";
import useClickOutside from "../../Hooks/useClickOutside";
import CustomerNavbar from "./CustomerNavbar";
import AuxiliaryText from "../common/Typography/AuxiliaryText";
import SearchField from "../common/SearchInput/SearchField";
import InteractiveText from "../common/Typography/InteractiveText";
import SpecialText from "../common/Typography/SpecialText";
import { useSelector, useDispatch } from 'react-redux';
import { setRedirectPath } from '../../Redux/Slice/authRedirectSlice';
import AuthButtons from '../common/AuthButtons/AuthButtons';
import QuoteRequestForm from '../QuoteRequestForm/QuoteRequestForm';
import Pro from "../common/Tags/Pro";

const CustomerHeader = ({ isCustomerDashboard }) => {
  const [notificationsAlerts, setNotificationsAlerts] = useState(false);
  const [postsOpen, setPostsOpen] = useState(false);
  const [scrolledVersion, setScrolledVersion] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isSidebarOpen, setIsSideBarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [quoteRequestOpen, setQuoteRequestOpen] = useState(false);
  const [pendingQuoteRequest, setPendingQuoteRequest] = useState(false);
  const { profilePicture, userPlan } = useSelector((state) => state.user);
  const isPro = userPlan?.plan?.name?.toLowerCase() === 'pro';
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const toggleDrawer = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "visible";
      document.body.style.width = `auto`;
    }
  }, [isOpen]);

  useEffect(() => {
    const responsive = () => {
      setIsMobile(window.matchMedia("(max-width: 1023px)").matches);
    };
    const event = () => {
      setScrolledVersion(() => {
        if (window.scrollY <= 0) {
          return false;
        }
        return true;
      });
    };

    responsive();
    document.addEventListener("scroll", event);
    window.addEventListener("resize", responsive);
    return () => {
      document.removeEventListener("scroll", event);
      window.removeEventListener("resize", responsive);
      document.body.style.overflow = "visible";
      document.body.style.width = `auto`;
    };
  }, []);

  const location = useLocation();

  // Pages that show only cross in header (no logo)
  const showCrossOnlyInHeader =
    location.pathname === "/customer-dashboard/posts/saved" ||
    location.pathname === "/customer-dashboard/posts/recently-viewed" ||
    location.pathname === "/customer-dashboard/inbox/reviews" ||
    location.pathname === "/customer-dashboard/inbox/chats" ||
    location.pathname === "/customer-dashboard/inbox/quotes" ||
    location.pathname === "/customer-dashboard/inbox/deleted" ||
    location.pathname === "/customer-dashboard/inbox/blocked" ||
    location.pathname.startsWith("/customer-dashboard/tickets");

  const { auth, setAuth } = useAuth();
  const [SignUpState, setSignUpState] = useState(false);
  const [SignIn, setSignIn] = useState(false);

  const [IsDropDownOpen, setDropDown] = useState(false);
  const { id: userId } = auth?.user ?? "";
  const ref = useRef(null);
  const notificationsRef = useRef(null);
  
  // Handle click outside for general dropdowns
  useClickOutside(ref, () => {
    setDropDown(false);
    setPostsOpen(false);
  });
  
  // Handle click outside specifically for notifications dropdown
  useClickOutside(notificationsRef, () => {
    setNotificationsAlerts(false);
  });

  // Handle automatic quote request form opening after login redirect
  useEffect(() => {
    if (auth?.user && pendingQuoteRequest) {
      setQuoteRequestOpen(true);
      setPendingQuoteRequest(false);
    }
  }, [auth?.user, pendingQuoteRequest]);

  // Handle Get free Quotes button click
  const handleRequestQuote = () => {
    if (auth?.user) {
      setQuoteRequestOpen(true);
    } else {
      setPendingQuoteRequest(true);
      dispatch(setRedirectPath(location.pathname + location.search));
      setSignIn(true);
    }
  };

  return (
    <>
      <Login
        SignIn={SignIn}
        setSignIn={setSignIn}
        SignUpState={SignUpState}
        setSignUpState={setSignUpState}
        onLoginSuccess={() => {
          if (pendingQuoteRequest) {
            setQuoteRequestOpen(true);
            setPendingQuoteRequest(false);
          }
        }}
      />
      <SignUp
        SignUpState={SignUpState}
        setSignUpState={setSignUpState}
        SignIn={SignIn}
        setSignIn={setSignIn}
      />
      
      {/* Quote Request Form Popup */}
      <QuoteRequestForm
        isOpen={quoteRequestOpen}
        onClose={() => setQuoteRequestOpen(false)}
      />

      {/* scrolledVersion={scrolledVersion || isOpen} */}
      <HeaderContainer>
        <div
          className={`
          ${
            isOpen
              ? "bg-pastalblue "
              : location.pathname === "/pricing" ||
              location.pathname === "/business-support-centre" || location.pathname === "/pro"
              ? "bg-transparent"
              : location.pathname === "/" ||
                location.pathname === "/customer-support-centre" ||
                location.pathname.includes("/services-guide/")
                // location.pathname === "/pricing" ||
                // location.pathname.includes("/councils-regulations") 
              ? "bg-transparent text-white"
              : "text-offblack"
          } 
          `}
        >
          <div
            className={
              isCustomerDashboard
                ? `${location.pathname === "/customer-dashboard/dashboard" ? "tp-container" : (location.pathname === "/customer-dashboard/posts/saved" || location.pathname === "/customer-dashboard/posts/recently-viewed") ? "tp-container" : (location.pathname === "/customer-dashboard/inbox/chats" || location.pathname === "/customer-dashboard/inbox/quotes" || location.pathname === "/customer-dashboard/inbox/deleted" || location.pathname === "/customer-dashboard/inbox/blocked" || location.pathname === "/customer-dashboard/inbox/reviews" || location.pathname.startsWith("/customer-dashboard/tickets")) ? "tp-container-small" : "tp-container-main"} flex items-center justify-between mx-auto h-[80px]`
                : location.pathname.includes("/NotHelpCentre")
                ? "flex items-center justify-between w-full max-w-3xl mx-auto h-[80px]"
                : location.pathname.includes("/poster-profile")
                ? "tp-container flex items-center justify-between mx-auto h-[80px]"
                : location.pathname === "/category" ||
                    location.pathname.startsWith("/category/")
                  ? "tp-container-fluid flex items-center justify-between mx-auto h-[80px] w-full"
                  : "tp-container-home flex items-center justify-between mx-auto h-[80px]"
            }
          >
            {!showCrossOnlyInHeader && (
              <div className={`${location.pathname.includes("customer-dashboard") ? "mr-12" : ""}`} onClick={() => setIsOpen(false)}>
                <Link to="/">
                  <img
                    className="w-[60px] h-[25px] sm:w-[65px] sm:h-[28px] lg:w-[70px] lg:h-[30px] cursor-pointer"
                    src={require("../../assets/img/trades-poster.png")}
                    alt="trades-poster"
                    onClick={() => window.scrollTo(0, 0)}
                  />
                </Link>
              </div>
            )}

            {location.pathname === "/customer-dashboard/dashboard" ? (
              <div>
                <SearchField placeholder={"Search"} />
              </div>
              ) : null}

            <div className="ml-auto">
              {!location.pathname.includes("/NotHelpCentre") && (
                <>
                  <div
                    className={"hidden lg:flex items-center"
                    }
                  >
                    {!location.pathname.includes("customer-dashboard") && (
                      <CustomerNavbar
                        scrolledVersion={scrolledVersion}
                        SignInState={SignIn}
                        setSignIn={setSignIn}
                        hideCategoriesAndPricing={Boolean(auth?.user)}
                      />
                    )}
                    
                    <div className="flex items-center">
                      {!auth?.user ? (
                        <div className="flex items-center">
                          <AuthButtons
                            variant="desktop"
                            onSignIn={() => setSignIn(!SignIn)}
                            onSignUp={() => setSignUpState(!SignUpState)}
                            onRequestQuote={handleRequestQuote}
                            showRequestQuote={true}
                          />
                        </div>
                      ) : (
                        <>
                        {/* Show cross icon for specific customer pages */}
                        {showCrossOnlyInHeader ? (
                          <div className="flex items-center">
                            <button
                              onClick={() => {
                                const isViewingMessage = new URLSearchParams(location.search).get('view') === 'message';
                                const isInboxPage = location.pathname === "/customer-dashboard/inbox/chats" || location.pathname === "/customer-dashboard/inbox/quotes";
                                if (isInboxPage && isViewingMessage) {
                                  navigate(location.pathname);
                                } else {
                                  navigate("/customer-dashboard/dashboard");
                                }
                              }}
                              className="flex items-center justify-center w-8 h-8 rounded-full transition-colors duration-200"
                            >
                              <i className="fi fi-rs-cross text-base text-offblack cursor-pointer"></i>
                            </button>
                          </div>
                        ) : (
                              <div className="flex items-center gap-10">

                                
                                <ul className={`${location.pathname.includes("customer-dashboard") ? "" : "ml-12"} flex items-center gap-5`}>
                            <li
                              className="cursor-pointer hover:bg-transparent hidden lg:block relative"
                              ref={ref}
                            >
                              <i
                                className="fi fi-rs-bell text-base flex items-center justify-center"
                                onClick={() =>
                                  setNotificationsAlerts(
                                    !notificationsAlerts
                                  )
                                }
                              ></i>
                              {/* Notification Badge */}
                              <div className="absolute -top-1 -right-1 w-2 h-2 bg-red-500 rounded-full"></div>
                              {notificationsAlerts && (
                                <div 
                                  ref={notificationsRef}
                                  className="absolute z-10 w-[350px] origin-top-right rounded-xl bg-white text-offblack pt-5 pb-10 mt-3 -right-14 shadow-2xl"
                                >
                                  <div
                                    class="w-0 h-0 
  border-l-[10px] border-l-transparent
  border-b-[15px] border-b-white
  border-r-[10px] border-r-transparent absolute left-[275px] -mt-8"
                                  ></div>
                                  {/* Heading */}
                                  <div className="flex items-center justify-between px-5 mb-5">
                                    <AuxiliaryText variant={"MenuDropdown"} className={"font-semibold"}>
                                      Notifications
                                    </AuxiliaryText>
                                  </div>

                                  {/* Notifications list */}
                                  <div className="border-t border-t-lightgray mx-5">
                                    <div className="border-b border-b-lightgray py-3 relative">
                                      <div className="flex items-center justify-between">
                                        <div className="flex items-center gap-x-2">
                                          <img
                                            src={profilePicture || Avtar}
                                            className="w-6 h-6 rounded-full object-cover"
                                            alt="Profile"
                                          />
                                          <SpecialText
                                            variant={"ProfileName"}
                                          >
                                            Trades poster
                                          </SpecialText>
                                        </div>
                                        <div className="flex items-center gap-2">
                                          <i className="fi fi-ss-bullet text-base text-primaryblue pt-1"></i>
                                          <SpecialText
                                            variant={"Date"}
                                            className={"text-mediumgray"}
                                          >
                                            1 minute ago
                                          </SpecialText>
                                        </div>
                                      </div>
                                      <SpecialText
                                        variant={"SubMenuDropdown"}
                                        className={
                                          "h-[20px] overflow-hidden text-ellipsis mt-2"
                                        }
                                      >
                                        Ensure seamless transactions and
                                        keep your business running
                                        smoothly with our straightforward
                                        billing section. Add/ remove
                                        payment methods, track and
                                        maintain record of all your
                                        pricing plans transactions with
                                        Trades Poster
                                      </SpecialText>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </li>
                            <li className="cursor-pointer hover:bg-transparent hidden lg:block relative">
                              <Link
                                to={"/customer-dashboard/inbox/chats"}
                              >
                                <i className="fi fi-rs-comment-alt-dots text-base flex items-center justify-center"></i>
                              </Link>
                              {/* Message Notification Badge */}
                              <div className="absolute -top-1 -right-1 w-2 h-2 bg-red-500 rounded-full"></div>
                            </li>
                          </ul>
                          <div ref={ref} className="relative">
                            <div className="relative inline-block">
                              <button
                                onClick={() => setDropDown(!IsDropDownOpen)}
                                type="button"
                                className="flex max-w-xs items-center rounded-full"
                                id="user-menu-button"
                                aria-expanded="false"
                                aria-haspopup="true"
                              >
                                <span className="sr-only">
                                  Open user menu
                                </span>
                                <img
                                  className="avatar-small object-cover"
                                  src={profilePicture || Avtar}
                                  alt="Profile"
                                />
                              </button>
                              {isPro && (
                                <div className="absolute -bottom-0.5 left-1/2 -translate-x-1/2">
                                  <Pro className="bg-primaryblue text-white" />
                                </div>
                              )}
                            </div>
                            {IsDropDownOpen && (
                              <div
                                className="absolute right-0 z-10 mt-2 w-60 origin-top-right rounded-xl bg-white text-offblack px-6 py-5 shadow-lg"
                                role="menu"
                                aria-orientation="vertical"
                                aria-labelledby="user-menu-button"
                                tabIndex={-1}
                              >
                                {/* Dashboard */}
                                <Link
                                  to={`/customer-dashboard/dashboard?userId=${userId}`}
                                  className="block py-2 hover:text-primaryblue ease-in-out w-full"
                                  onClick={() => setDropDown(!IsDropDownOpen)}
                                >
                                  <AuxiliaryText variant={"MenuDropdown"}>
                                    Dashboard
                                  </AuxiliaryText>
                                </Link>

                                {/* Messages */}
                                <Link
                                  to={`/customer-dashboard/inbox/chats?userId=${userId}`}
                                  className="flex items-center gap-2 py-2 hover:text-primaryblue ease-in-out w-full"
                                  onClick={() => setDropDown(!IsDropDownOpen)}
                                >
                                  <AuxiliaryText variant={"MenuDropdown"}>
                                    Messages
                                  </AuxiliaryText>
                                  <span className="inline-flex items-center justify-center rounded-full bg-red-500 text-white text-[11px] min-w-5 h-5 px-1 leading-none">
                                    2
                                  </span>
                                </Link>

                                {/* My Posts */}
                                <button
                                  onClick={() => {
                                    setPostsOpen(!postsOpen);
                                  }}
                                  className="flex justify-between py-2 hover:text-primaryblue ease-in-out w-full my-1"
                                >
                                  <AuxiliaryText variant={"MenuDropdown"}>
                                    My Posts
                                  </AuxiliaryText>
                                  <i className="fi fi-rs-angle-down text-sm text-offblack"></i>
                                </button>
                                {postsOpen && (
                                  <ul className="text-start px-4">
                                    <li>
                                      <Link
                                        to={`/customer-dashboard/posts/saved?userId=${userId}`}
                                        onClick={() => {
                                          setPostsOpen(!postsOpen);
                                          setDropDown(!IsDropDownOpen);
                                        }}
                                        className="block py-2 hover:text-primaryblue ease-in-out w-full my-1"
                                      >
                                        <AuxiliaryText variant={"SubMenuDropdown"}>
                                          Saved
                                        </AuxiliaryText>
                                      </Link>
                                    </li>
                                    <li>
                                      <Link
                                        to={`/customer-dashboard/posts/recently-viewed?userId=${userId}`}
                                        onClick={() => {
                                          setPostsOpen(!postsOpen);
                                          setDropDown(!IsDropDownOpen);
                                        }}
                                        className="block py-2 hover:text-primaryblue ease-in-out w-full my-1"
                                      >
                                        <AuxiliaryText variant={"SubMenuDropdown"}>
                                          Recently Viewed
                                        </AuxiliaryText>
                                      </Link>
                                    </li>
                                  </ul>
                                )}

                                {/* Following */}
                                {/* <Link
                                  to={`/customer-dashboard/following?userId=${userId}`}
                                  className="block py-2 hover:text-primaryblue ease-in-out w-full"
                                  onClick={() => setDropDown(!IsDropDownOpen)}
                                >
                                  <AuxiliaryText variant={"MenuDropdown"}>
                                    Following
                                  </AuxiliaryText>
                                </Link> */}

                                {/* Reviews */}
                                <Link
                                  to={`/customer-dashboard/inbox/reviews?userId=${userId}`}
                                  className="block py-2 hover:text-primaryblue ease-in-out w-full"
                                  onClick={() => setDropDown(!IsDropDownOpen)}
                                >
                                  <AuxiliaryText variant={"MenuDropdown"}>
                                    Reviews
                                  </AuxiliaryText>
                                </Link>

                                {/* Preferences */}
                                <Link
                                  to={`/customer-dashboard/settings/notification-preferences?userId=${userId}`}
                                  className="block py-2 hover:text-primaryblue ease-in-out w-full"
                                  onClick={() => setDropDown(!IsDropDownOpen)}
                                >
                                  <AuxiliaryText variant={"MenuDropdown"}>
                                    Preferences
                                  </AuxiliaryText>
                                </Link>

                                {/* Account & profile */}
                                <Link
                                  to={`/customer-dashboard/account?userId=${userId}`}
                                  className="block py-2 hover:text-primaryblue ease-in-out w-full"
                                  onClick={() => setDropDown(!IsDropDownOpen)}
                                >
                                  <AuxiliaryText variant={"MenuDropdown"}>
                                    Account & profile
                                  </AuxiliaryText>
                                </Link>

                                {/* Help & Support */}
                                <Link
                                  to="/HelpCentre"
                                  className="block py-2 hover:text-primaryblue ease-in-out w-full"
                                  onClick={() => setDropDown(!IsDropDownOpen)}
                                >
                                  <AuxiliaryText variant={"MenuDropdown"}>
                                    Help & Support
                                  </AuxiliaryText>
                                </Link>

                                {/* Log out */}
                                <Link
                                  to="/"
                                  className="block py-2 hover:text-primaryblue ease-in-out w-full"
                                  onClick={() => {
                                    setAuth({
                                      user: null,
                                      roles: null,
                                      accessToken: "",
                                    });
                                    localStorage.removeItem("LoginSession");
                                    setDropDown(!IsDropDownOpen);
                                  }}
                                >
                                  <AuxiliaryText variant={"MenuDropdown"}>
                                    Log out
                                  </AuxiliaryText>
                                </Link>
                              </div>
                            )}
                          </div>
                          {!location.pathname.includes("customer-dashboard") && (
                            <div className="ml-10">
                              <MainButton
                                variant="large"
                                onClick={handleRequestQuote}
                              >
                                Get Quotes
                              </MainButton>
                            </div>
                          )}
                              </div>
                        )}
                        </>
                      )}
                    </div>
                  </div>
                  {/* {!location?.pathname?.includes("CustomerDashboard") ? ( */}
                  <button
                    onClick={toggleDrawer}
                    className="text-black lg:hidden"
                  >
                    {isOpen ? (
                      <>
                        <i className="fi fi-rs-cross text-base text-offblack"></i>
                        {/* <CircularButton variant={"cross"} /> */}
                      </>
                    ) : (
                      <>
                        <i
                          className={`${
                            location.pathname === "/" ||
                            location.pathname === "/business-support-centre" ||
                            location.pathname === "/customer-support-centre" ||
                            location.pathname.includes("/services-guide/")
                            // location.pathname === "/pricing" ||
                            // location.pathname.includes(
                            //   "/councils-regulations"
                            // )
                              ? "fi fi-rr-menu-burger text-[26px] text-white"
                              : "fi fi-rr-menu-burger text-[26px] text-offblack"
                          } `}
                        ></i>
                      </>
                    )}
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
        {isMobile && isOpen ? (
          <div
            //<motion.div
            // initial={{ x: "100%" }}
            // animate={{ x: "0%" }}
            // transition={{ type: "tween", duration: 0.7 }}
            className={
              !auth?.user
                ? "bg-pastalblue h-[calc(100vh_-_80px)] pb-6 pt-28 px-3 fixed overflow-y-auto w-[100vw] z-10 top-[80px] left-0 block lg:hidden overflow-hidden"
                : "bg-pastalblue h-[calc(100vh_-_80px)] px-3 pt-10 fixed z-10 top-[80px] left-0 overflow-y-auto w-[100vw] pb-32 block lg:hidden overflow-hidden"
            }
          >
            {!auth?.user ? (
              <>
                <CustomerNavbar
                  isMobile={isMobile}
                  toggleDrawer={toggleDrawer}
                  isOpen={isOpen}
                  setIsOpen={setIsOpen}
                  SignUpState={SignUpState}
                  setSignUpState={setSignUpState}
                  auth={auth}
                  setAuth={setAuth}
                  setSignIn={setSignIn}
                  hideCategoriesAndPricing={false}
                />
              </>
            ) : (
              <>
                <CustomerSidebarDrawer
                  isMobile={isMobile}
                  toggleDrawer={() => setIsSideBarOpen(!isSidebarOpen)}
                  isOpen={isSidebarOpen}
                  setIsOpen={setIsSideBarOpen}
                  SignUpState={SignUpState}
                  setSignUpState={setSignUpState}
                  auth={auth}
                  setAuth={setAuth}
                  close={() => setIsOpen(!isOpen)}
                />
              </>
            )}
          </div>
        ) : (
          ""
        )}
      </HeaderContainer>
    </>
  );
};

const HeaderContainer = ({ scrolledVersion, isMobile, children }) => {
  const location = useLocation();
  const isCustomerDashboard = location.pathname.includes("customer-dashboard");
  if (!isCustomerDashboard) {
    return (
      <div
        // initial={{ y: "-100%" }}
        // animate={{ y: "0%" }}
        // transition={{ type: "tween" }}
        className={
          location.pathname === "/"
            ? "absolute bg-transparent top-0 w-full z-40"
            : "absolute bg-transparent top-0 w-full z-40"
        }
      >
        {children}
      </div>
    );
  }
  return (
    <div
      className={`${isCustomerDashboard ? "" : "absolute top-0"} w-full z-40 ${
        isMobile ? "bg-white" : "bg-transparent"
      }`}
    >
      {children}
    </div>
  );
};

export default CustomerHeader;